  (function () {
  const SECTION_SELECTOR = '.js-pickup-drawer';
  const OPEN_BTN_SELECTOR = '.js-show-pickup-info';
  const STORE_NAME_SELECTOR = '.pickup-status .mb-0'; // línea “Retiro disponible en …”
  const UL_SELECTOR = '.drawer__content ul[role="list"]';

  // === CONFIG ===
  // Usa una versión estable de API para evitar warnings en tiendas que aún no soportan 2025-01
  const STOREFRONT_API_URL = '/api/2024-10/graphql.json';
  const STOREFRONT_API_TOKEN = 'c25679a57e5feb31350d9ceb2f6191cb'; // 👈 Pega aquí tu Storefront token real
  const MAX_LOCATIONS = 25;

  // Guardarraíl: no ejecutar sin token real
  if (!STOREFRONT_API_TOKEN || STOREFRONT_API_TOKEN === 'token') {
    console.warn('[MF-pickup-closest] Falta Storefront token. El script no se ejecutará.');
    return;
  }

  const GQL = `
    query NearestLocations($lat: Float!, $lon: Float!, $first: Int!) {
      locations(first: $first, sortKey: DISTANCE, near: { latitude: $lat, longitude: $lon }) {
        edges { node { id name address { latitude longitude city } } }
      }
    }
  `;

  const km = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const toRad = d => d * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat/2)**2 + Math.cos(toRad(lat1))*Math.cos(toRad(lat2))*Math.sin(dLon/2)**2;
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)));
  };

  async function fetchNearest(lat, lon) {
    try {
      const res = await fetch(STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
        },
        body: JSON.stringify({ query: GQL, variables: { lat, lon, first: MAX_LOCATIONS } }),
        credentials: 'same-origin'
      });

      if (!res.ok) {
        console.warn(`[MF-pickup-closest] Storefront API ${res.status}: ${res.statusText}`);
        return [];
      }

      const json = await res.json();
      if (json.errors) {
        console.warn('[MF-pickup-closest] GraphQL errors:', json.errors);
        return [];
      }

      return (json?.data?.locations?.edges || []).map(e => e.node);
    } catch (err) {
      console.warn('[MF-pickup-closest] Error de red/parseo:', err);
      return [];
    }
  }

  function reorderListByNames(ul, orderedNames) {
    const items = Array.from(ul.querySelectorAll(':scope > li'));
    if (!items.length || !orderedNames?.length) return;

    const norm = s => (s || '').toString().trim().toLowerCase();
    const liByName = new Map();
    items.forEach(li => {
      const n = li.getAttribute('data-location-name') || li.querySelector('h3')?.textContent || '';
      const key = norm(n);
      if (key) liByName.set(key, li);
    });

    const fragment = document.createDocumentFragment();
    orderedNames.forEach(n => {
      const li = liByName.get(norm(n));
      if (li) fragment.appendChild(li);
    });

    // agrega el resto (por si algún nombre no coincidió)
    items.forEach(li => { if (!fragment.contains(li)) fragment.appendChild(li); });

    ul.appendChild(fragment);
  }

  function updateTeaserToFirst(ul) {
    const firstLi = ul.querySelector(':scope > li');
    if (!firstLi) return;
    const h3 = firstLi.querySelector('h3');
    if (!h3) return;

    const teaserLine = document.querySelector(STORE_NAME_SELECTOR);
    if (!teaserLine) return;

    // Reemplaza solo el <strong> con el nombre de la primera sucursal
    const tmp = document.createElement('div');
    tmp.innerHTML = teaserLine.innerHTML;
    const strong = tmp.querySelector('strong');
    if (strong) strong.textContent = h3.textContent.trim();
    teaserLine.innerHTML = tmp.innerHTML;
  }

  function addApproxDistance(ul, userLat, userLon, locationsByName) {
    const items = Array.from(ul.querySelectorAll(':scope > li'));
    items.forEach(li => {
      const name = (li.getAttribute('data-location-name') || li.querySelector('h3')?.textContent || '').trim().toLowerCase();
      const loc = locationsByName.get(name);
      if (!loc?.address?.latitude || !loc?.address?.longitude) return;

      const d = km(userLat, userLon, loc.address.latitude, loc.address.longitude);
      let p = li.querySelector('.pickup-distance');
      if (!p) {
        p = document.createElement('p');
        p.className = 'pickup-distance text-sm';
        const h3 = li.querySelector('h3');
        if (h3) h3.insertAdjacentElement('afterend', p);
      }
      p.textContent = `≈ ${d.toFixed(1)} km`;
    });
  }

  async function geolocateAndSort(ul) {
    if (!navigator.geolocation) return;

    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(async (pos) => {
        try {
          const { latitude, longitude } = pos.coords || {};
          if (latitude == null || longitude == null) return resolve();

          const nearest = await fetchNearest(latitude, longitude);
          const orderedNames = nearest.map(n => n.name);

          reorderListByNames(ul, orderedNames);
          updateTeaserToFirst(ul);

          const byName = new Map(nearest.map(n => [n.name.trim().toLowerCase(), n]));
          addApproxDistance(ul, latitude, longitude, byName);
          resolve();
        } catch (e) {
          console.warn('[MF-pickup-closest] Geolocate/sort error:', e);
          resolve();
        }
      }, () => resolve(), { enableHighAccuracy: false, maximumAge: 5 * 60 * 1000, timeout: 5000 });
    });
  }

  function init() {
    const drawer = document.querySelector(SECTION_SELECTOR);
    const btns = document.querySelectorAll(OPEN_BTN_SELECTOR);
    if (!drawer || !btns.length) return;

    let sortedOnce = false;
    btns.forEach(btn => {
      btn.addEventListener('click', async () => {
        if (sortedOnce) return;
        const ul = drawer.querySelector(UL_SELECTOR);
        if (!ul) return;
        sortedOnce = true;
        await geolocateAndSort(ul);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
